import { Text } from '@chakra-ui/react'
import { memo, useState } from 'react'
import { useProductTypes } from '../../../hooks/useSystem'
import { capitalizeWords, replaceUnderscore } from '../../../utils/functions/formatters'
import SelectAsInput from './SelectAsInput'

interface Item {
  id: string
  name: string
}

const FormProductTypeSelect = ({
  value,
  onAdd,
  onRemove,
  name,
  labelOverride,
  isDisabled,
  brand,
  placeholder,
  hasSetValueNull,
}: {
  value: Item | null
  onAdd: (item: Item) => void
  onRemove?: () => void
  name: string
  labelOverride?: string
  isDisabled?: boolean
  brand?: string
  placeholder?: string
  hasSetValueNull?: boolean
}) => {
  const [productTypeSearch, setProductTypeSearch] = useState('')

  const productTypes = useProductTypes(
    { search: productTypeSearch, page: 1, page_size: 15, brand: brand, all: true },
    productTypeSearch.length > 1,
  )

  return (
    <>
      <Text color="neutral.900" fontWeight="400" textStyle="b-sm" mb="8px">
        {labelOverride ?? capitalizeWords(name)}
      </Text>
      <SelectAsInput
        placeholder={placeholder ?? `Search for a ${replaceUnderscore(name)}`}
        isDisabled={isDisabled}
        h="40px"
        value={value}
        w="100%"
        onChange={(v) => {
          if (v)
            onAdd({
              ...v,
              name: v.name,
            } as Item)
          if (!v && onRemove) onRemove()
        }}
        search={productTypeSearch}
        onSearchChange={(v) => setProductTypeSearch(v)}
        options={
          (productTypes.data?.success
            ? productTypes.data.data.map(
                (type: {
                  id: string
                  brand: {
                    id: string
                    name: string
                  }
                  member: {
                    id: string
                    name: string
                  }
                }) => ({
                  id: type.id,
                  name: type.id,
                  detail: (type.brand && `Brand: ${type.brand.name}`) || (type.member && `Member: ${type.member.name}`),
                })
              )
            : []) || []
        }
        isLoading={productTypes.isFetching}
        fontSize="12px"
        hasSetValueNull={hasSetValueNull}
      />
    </>
  )
}

const isEqual = (
  prevProps: { value: Item | null; isDisabled?: boolean },
  nextProps: { value: Item | null; isDisabled?: boolean }
) => {
  return prevProps.value === nextProps.value && prevProps.isDisabled === nextProps.isDisabled
}

export default memo(FormProductTypeSelect, isEqual)
